<template>
  <form @submit.prevent="onSearch">
    <div class="row mt-5">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"/>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import Datepicker from '@/components/picker/Datepicker.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([ 'search' ]);

// Use toRefs to maintain reactivity
const { filters } = toRefs(props);

// Function to parse DD.MM.YYYY format into a Date object
function parseDate(dateString) {
  if (!dateString) return null;
  const [day, month, year] = dateString.split('.'); // Split into [day, month, year]
  return new Date(`${year}-${month}-${day}`); // Return as a valid Date object
}

// Function to format a Date object into 'YYYY-MM-DD' string
function formatDate(date) {
  if (!date) return null; // Handle null or undefined dates
  const d = new Date(date);
  return d.toISOString().split('T')[0]; // Extract only the date part (YYYY-MM-DD)
}

function onSearch() {
  const formattedFilters = {
    ...filters.value,
    startDate: filters.value.startDate ? formatDate(parseDate(filters.value.startDate)) : null,
    endDate: filters.value.endDate ? formatDate(parseDate(filters.value.endDate)) : null,
  };
  emit('search', formattedFilters);
}
</script>

<style scoped>
</style>
